<ndt-system-device-register-view
   [callState]="callState$ | async"
   [dataSource]="dataSource$ | async"
   [isLoading]="isLoading$ | async"
   [hasNextPage]="hasNextPage$ | async"
   [pagingCallState]="pagingCallState$ | async"
   [totalCount]="totalCount$ | async"
   [name]="entityName"
   [columns]="columns"
   [devicePrivileges]="devicePrivileges$ | async"
   (create)="onCreate()"
   (loadMore)="onLoadMore()"
   (quickFilterChange)="onQuickFilterChange($event)"
   (resetHackedAndFraud)="onResetHackedAndFraud($event)"
   (rebootPhone)="onRebootPhone($event)"
   (releaseFromExtension)="onReleaseFromExtension($event)"
   (releaseToSystemInventory)="onReleaseToSystemInventory($event)"
   (deleteDevice)="onDeleteDevice($event)"
   (resetPhoneZtp)="onResetPhoneZtp($event)"
   (orderingOptionsChange)="onOrderingOptionsChange($event)"
   [orderingOptions]="orderingOptions$ | async"
></ndt-system-device-register-view>
